import { invert, mapKeys, result } from 'libraries/lodash'

const FILTER_NAME = 'n'
const FILTER_VALUE = 'v'
const FILTER_OPERATOR = 'o'

const keyTranslator = {
  name: FILTER_NAME,
  value: FILTER_VALUE,
  operator: FILTER_OPERATOR
}

export const parametersToString = params => {
  const mapKeyName = (v, k) => keyTranslator[k] || k
  return JSON.stringify(
    params
      .filter(param => param.value.length > 0)
      .map(param => mapKeys(param, mapKeyName))
  )
}

export const parametersFromString = str => {
  const invKeys = invert(keyTranslator)
  const mapKeyName = (v, k) => invKeys[k] || k
  try {
    return JSON.parse(str).map(param => mapKeys(param, mapKeyName))
  } catch (e) {
    return []
  }
}

export const extractParameters = props => {
  return result(props, 'parameters', '')
}
